import React, {FC, RefObject, useEffect} from 'react';
import {makeStyles} from '@material-ui/core';

interface IFileInputProps {
  name: string;
  inputRef: RefObject<HTMLInputElement>;
  type?: string;
  accept: string;
  clickHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  cancelHandler?: () => void;
}

export const FileInput: FC<IFileInputProps> = ({
  name,
  inputRef,
  type = 'file',
  accept,
  clickHandler,
  cancelHandler,
}) => {
  const {root} = useStyles();

  useEffect(() => {
    const input = inputRef?.current;
    if (!input || !cancelHandler) {
      return undefined;
    }

    const handleCancel = () => cancelHandler();
    input.addEventListener('cancel', handleCancel);

    return () => {
      input.removeEventListener('cancel', handleCancel);
    };
  }, [cancelHandler, inputRef]);

  return <input name={name} className={root} ref={inputRef} type={type} onChange={clickHandler} accept={accept} />;
};

const useStyles = makeStyles(() => ({
  root: {
    display: 'none',
  },
}));
